import React from "react";
import type { FC } from 'react';
import { useStyles } from "./RecentlyCards.styles";
import type { IRecentlyCardsProps } from './RecentlyCards.types';

export const RecentlyCards : FC<IRecentlyCardsProps> = ({ children, ...props }) => {
  const classes = useStyles(props);

  const [childrenHeaderRecently, ...childrenCards] = children;

  return (
    <div className={classes.root}>
      {childrenHeaderRecently}
      <div className={classes.cards}>{childrenCards}</div>
    </div>
  );
};
